import { LimitOffsetPaging } from "../paged-results/limit-offset-paging.model";

export class ClientEspNdcFilters {
  ndc: string = '';
  drugDescription: string = '';
  selectedManufacturers: string[] = [];
}

export class ClientEspNdcListSettings {
  filters: ClientEspNdcFilters = new ClientEspNdcFilters();
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}